import { generateQuery } from 'utils';
import http from 'utils/http';

export const getFlows = (params = {}) => {
  const query = generateQuery([
    params.status ? `status=${params.status}` : '',
    params.page > 1 ? `page=${params.page}` : '',
    params.page_size ? `page_size=${params.page_size}` : '',
  ]);
  return http
    .get(`v1/organizations/{{organizationId}}/flows/${query}`)
    .then((res) => res.data);
};

export const getFlow = (flowId) => http
  .get(`v1/organizations/{{organizationId}}/flows/${flowId}`)
  .then((res) => res.data);

export const createFlow = (data) => http
  .post('v1/organizations/{{organizationId}}/flows/', data)
  .then((res) => res.data);

export const updateFlow = (flowId, data) => http
  .patch(`v1/organizations/{{organizationId}}/flows/${flowId}/`, data)
  .then((res) => res.data);

export const deleteFlow = (flowId) => http
  .delete(`v1/organizations/{{organizationId}}/flows/${flowId}/`)
  .then((res) => res.data);

export const createFlowNode = (flowId, data) => http
  .post(`v1/organizations/{{organizationId}}/flows/${flowId}/nodes/`, data)
  .then((res) => res.data);

export const updateFlowNode = (flowId, nodeId, data) => http
  .patch(`v1/organizations/{{organizationId}}/flows/${flowId}/nodes/${nodeId}/`, data)
  .then((res) => res.data);

export const deleteFlowNode = (flowId, nodeId) => http
  .delete(`v1/organizations/{{organizationId}}/flows/${flowId}/nodes/${nodeId}/`)
  .then((res) => res.data);

export const triggerFlowForCustomer = (customerId, flowId) => http
  .post(`v1/organizations/{{organizationId}}/customers/${customerId}/flows/trigger/`, { flow_id: flowId })
  .then((res) => res.data);

export const triggerFlowForCompany = (companyId, flowId) => http
  .post(`v1/organizations/{{organizationId}}/companies/${companyId}/flows/trigger/`, { flow_id: flowId })
  .then((res) => res.data);
